import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CALENDAR_DEFAULT_USER_FILTER, CALENDAR_DEFAULT_VIEW } from '../sic-lib/defaults';
import { CalendarView } from '../sic-lib/enums/CalendarView';
import { CalendarUserFilterItem } from '../sic-lib/types/CalendarUserFilter';

export interface CalendarState {
    calendarView: CalendarView;
    showWeekends: boolean;
    userFilter: CalendarUserFilterItem;
}

const initialState: CalendarState = {
    calendarView: CALENDAR_DEFAULT_VIEW,
    showWeekends: false,
    userFilter: CALENDAR_DEFAULT_USER_FILTER,
};

const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setCalendarView(state, action: PayloadAction<CalendarView>) {
            state.calendarView = action.payload;
        },
        setShowWeekends(state, action: PayloadAction<boolean>) {
            state.showWeekends = action.payload;
        },
        setUserFilter(state, action: PayloadAction<CalendarUserFilterItem>) {
            state.userFilter = action.payload;
        },
    },
});

export const { setCalendarView, setShowWeekends, setUserFilter } = calendarSlice.actions;

export default calendarSlice.reducer;
